import React from 'react';
import { Reveal } from './Reveal';
import { volumes } from '../data/volumes';
export function Modules() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-139" data-mp="1r5ajy1actj1h">
      <div className="mx-auto max-w-6xl" data-id="element-140" data-mp="1vx2e0lspy6wd">
        <Reveal className="mx-auto max-w-3xl text-center" data-id="element-141" data-mp="1vydeabmygwiq">
          <h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-142" data-mp="20vvo048srfrs">
            📚 6 Tomi <span className="text-sage" data-id="element-143" data-mp="20xzpygn4y4pf">Terapeutici Completi</span>
          </h2>
          <p className="mt-5 text-slate" data-id="element-144" data-mp="147pd4zla7r52">
            Ogni ferita coperta. Ogni schema decodificato. Ogni strumento pronto da stampare e usare oggi.
          </p>
        </Reveal>
        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-145" data-mp="1d5t265vh761m">
          {volumes.map((volume, index) => <Reveal key={volume.number} delay={index % 2 * 0.06} className="h-full" data-id="element-146" data-mp="1i78mfvptx8iy" data-mpi={index}>
              <article className={`flex h-full flex-col rounded-2xl border bg-surface p-8 shadow-premium ${volume.featured ? 'border-amber/50' : 'border-navy/10'}`} data-id="element-147" data-mp="2oky3p6jveyjn">
                <p className="text-xs font-bold uppercase tracking-[0.15em] text-sage" data-id="element-148" data-mp="1trubmvzmsdn">{volume.number}</p>
                <h3 className="mt-4 font-serif text-2xl leading-tight text-navy" data-id="element-149" data-mp="3u06qf4ge3cen">{volume.title}</h3>
                <p className="mt-1 font-serif text-lg italic leading-snug text-amber" data-id="element-150" data-mp="3oyhjo1079kwd">{volume.subtitle}</p>
                <p className="mt-4 flex-1 text-sm leading-7 text-slate" data-id="element-151" data-mp="3k064dar4yi6r">{volume.description}</p>
                <ul className="mt-6 flex flex-wrap gap-2" data-id="element-152" data-mp="3f35yazuadffn">
                  {volume.tags.map(tag => <li key={tag} className="rounded-full bg-amber-pale px-3 py-1.5 text-xs font-semibold text-navy" data-id="element-153" data-mp="3a9l9nyel1xt4">
                      {tag}
                    </li>)}
                </ul>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}